    function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+d.toUTCString();
            var path = "path=/";
            document.cookie = cname + "=" + cvalue + "; " + expires + "; " + path;
        } 



    function setTimeCookie(cname, cvalue, exMin) {
            var d = new Date();
            d.setTime(d.getTime() + (exMin*60*1000));
            var expires = "expires="+d.toUTCString();
            var path = "path=/";

            if(exMin == 0) {
                document.cookie = cname + "=" + cvalue + "; " + path;
            } else {
                document.cookie = cname + "=" + cvalue + "; " + expires + "; " + path;
            }
    } 


    function removeCookie(cname) {
            document.cookie = cname +"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    }


    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i=0; i<ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1);
            if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
        }
        return "";
    } 
    
    function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                return sParameterName[1];
            }
        }
    }
    
    var utm_source = GetURLParameter('utm_source'); 
	var utm_medium = GetURLParameter('utm_medium'); 
	
	
	//console.log(utm_medium);
	if(typeof(utm_medium) != "undefined") {
      utm_medium = utm_medium.toLowerCase();
      
      if(utm_medium == 'ppc' || utm_medium == 'adcense') {  		
          setCookie('psmppc', 'psmedia', 180); 

      }
    }
	//console.log(utm_source);
    if(typeof(utm_source) != "undefined") {
     // Set new cookie value
      	//console.log('condition');
      	//console.log(utm_source);
        setCookie('nonpsmutmsource', utm_source, 1);  
    }

    function gerReferrerUrl() {
        //return document.referrer;  
      if(document.referrer) {
        return document.referrer.match(/:\/\/(.[^/]+)/)[1];
      } else {
       	return 'www.designpublic.com';
      }
    }

	var referrer_url = gerReferrerUrl();
	
	if(typeof(referrer_url) != "undefined" && referrer_url.indexOf('www.designpublic.com') < 0) {
     // Set new referrer_url value
        setCookie('referrer_url', referrer_url, 1);  
    }